import axiosClient from '../configs/axios';


class CustomerPoService {
    // Get list 
    async getScheduleEntryList(params) {
        try {
            const response = await axiosClient.get(
                `/schedule-entry/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
      async addScheduleEntry(data) {
        try {
            const response = await axiosClient.post(
                '/schedule-entry/add',
                data,
                data.upload_po ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteScheduleEntry(data) {
        try {
            const response = await axiosClient.put(`/schedule-entry/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // GET FOR SO
     async getsalesofficerdata(cust_id) {
            try {
                const response = await axiosClient.get(
                    `/schedule-entry/salesofficernamelist?cust_id=${cust_id}`
                );
                return response.data;
            } catch (error) {
                throw error;
            }
        }

        async getdatefilter(params) {
  try {
   
    const response = await axiosClient.get('/schedule-entry/datefilter', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}



        

}

export default new CustomerPoService(); 